import React from "react";
import ContentBelow from "../../components/ContentBelow";
import Head from "../../components/Head";
import FAQTreeView from "./FAQTreeView";
import classes from "../../components/FAQ.module.css";

import background from "../../images/BlogHeadingBackGround.jpg";
import RAFNumber from "../../images/FAQ/FAQ RAF call centre number.png";

export default function RAFCallCentreNumber() {
  function ArticleLayout({ children }) {
    return (
      <div className={`container mt-5 ${classes.article}`}>
        <div className="row">
          {/* LEFT SIDEBAR */}
          <aside className="col-lg-3 col-md-4 mb-4">
            <FAQTreeView />
          </aside>

          {/* MAIN CONTENT */}
          <main className="col-lg-9 col-md-8">
            <div className="row">
              {/* IMAGE */}
              <div className="col-lg-6 mb-3">
                <img
                  src={RAFNumber}
                  alt="RAF Call Centre Number"
                  className="img-fluid rounded"
                />
              </div>

              {/* TEXT */}
              <div className="col-lg-6">
                <h3 className="mb-3">What is the RAF Call Centre number?</h3>

                <div className="article-content">{children}</div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }

  function ArticleData() {
    return (
      <>
        <p>
          The official national Road Accident Fund Contact Centre number is:
        </p>

        <p>
          <strong>087 820 1 111</strong> (Mon–Fri, 07:30–16:30).
        </p>

        <p>This is the main line for queries like:</p>

        <ul>
          <li>Checking claim status</li>
          <li>Document submissions</li>
          <li>General questions about your RAF claim</li>
        </ul>

        <p>
          Have your claim reference number, ID number, and accident details
          ready - calls can get busy, so patience helps!
        </p>

        <h5 className="mt-3">Other ways to reach them:</h5>

        <ul>
          <li>Email: contactcentre@raf.co.za</li>
          <li>SMS: 44930 (for quick queries)</li>
          <li>
            Online: Self Service Portal at selfservice.raf.co.za (often faster
            for status checks)
          </li>
        </ul>

        <p>
          If you're calling often due to long delays or backlogs (common in RAF
          claims), remember: The process can take years!
        </p>

        <h4>Summary</h4>

        <ul>
          <li>
            The Road Accident Fund Contact Centre can be reached on 087 820 1
            111 during weekdays from 07:30 to 16:30.
          </li>

          <li>
            The contact centre assists with claim status updates, document
            submissions, and general enquiries.
          </li>

          <li>
            You can also contact the RAF through email, SMS, or their online
            self-service portal.
          </li>

          <li>
            Due to delays and backlogs, RAF claim processes can take several
            years.
          </li>
        </ul>
      </>
    );
  }

  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">FAQs</h2>
      </Head>

      <ContentBelow>
        <div className="col-lg-11 mt-4 mx-auto">
          <h2 className={classes.h2}>
            Frequently Asked <span style={{ color: "#68B0ED" }}>Questions</span>
          </h2>

          <p className="text-center">
            Got questions? Our FAQs have the answers!
          </p>
        </div>

        <div className="row">
          <div className="col-md-5 col-lg">
            <ArticleLayout>
              <ArticleData />
            </ArticleLayout>
          </div>
        </div>
      </ContentBelow>
    </>
  );
}
